export default "__VITE_ASSET__B56N3vgX__"